var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.004,
    height: 12.047,
    viewBox: "0 0 21.004 12.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "up_arrow",
    "data-name": "up arrow",
    d: "M20,9.753a2.88,2.88,0,0,0-.746-.926Q15.025,4.6,10.793.372A1.028,1.028,0,0,0,9.484.144a1.368,1.368,0,0,0-.271.221Q4.789,4.786.364,9.206a1.011,1.011,0,0,0-.308,1.1.969.969,0,0,0,.8.681.945.945,0,0,0,.752-.192,2.321,2.321,0,0,0,.232-.209L9.8,2.638c.2-.2.2-.2.4-.007l7.994,7.986a1.03,1.03,0,0,0,1.34.225,1.232,1.232,0,0,0,.469-.66Z",
    transform: "translate(0.504 0.521)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/up arrow.d8d9f764b9f361ea5beb371a8e0ddf2f.svg";
export { ForwardRef as ReactComponent };